<div id="search-error-section">
    <img [src]="warningIconPath" alt="warning icon" id="warning-icon">
    <p id="error-section"> {{ error }}. Please, try again later</p>
</div>
